"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotEventHandler = void 0;
const e_pointer_event_type_1 = require("./internal-events/e-pointer-event-type");
const rc_js_util_1 = require("rc-js-util");
const e_mouse_event_type_1 = require("./internal-events/e-mouse-event-type");
const pointer_event_provider_1 = require("./internal-events/pointer-event-provider");
const chart_pointer_event_1 = require("./internal-events/chart-pointer-event");
/**
 * @internal
 */
class PlotEventHandler {
    constructor(initialState, plot) {
        this.plot = plot;
        this.pointerEvent = chart_pointer_event_1.ChartPointerEvent.createOneEmpty();
        this.currentState = initialState;
        this.pointerEventProvider = new pointer_event_provider_1.PointerEventProvider(plot.attachPoint);
    }
    onCanvasResized(canvasDims) {
        this.pointerEventProvider.setCanvasDims(canvasDims);
    }
    onPointerEvent(eventType, $event) {
        this.pointerEventProvider.updatePointerEvent($event, this.pointerEvent);
        if (!this.plot.plotDimensionsOBL.clipSpaceArea.interactiveRange.isPointInRange(this.pointerEvent.pointerClipPosition)) {
            // it's outside of the plot's range, act as if it's an out event
            eventType = e_pointer_event_type_1.EPointerEventType.Out;
        }
        const newState = this.currentState.handlePointerEvent(eventType, this.pointerEvent);
        if (newState != null) {
            DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
                const prevState = this.currentState.constructor.name;
                const curState = newState.constructor.name;
                const eventName = e_pointer_event_type_1.EPointerEventTypeNames[eventType];
                const name = this.plot.plotName == null ? "" : `${this.plot.plotName} `;
                rc_js_util_1._Debug.verboseLog(`${name}${prevState} -> ${curState} (${eventName})`);
            });
            this.currentState = newState;
        }
    }
    onMouseEvent(eventType, $event) {
        this.pointerEventProvider.updatePointerEvent($event, this.pointerEvent);
        if (!this.plot.plotDimensionsOBL.clipSpaceArea.interactiveRange.isPointInRange(this.pointerEvent.pointerClipPosition)) {
            // it's outside of the plot's range, only zoom is supported... do nothing
            return;
        }
        const newState = this.currentState.handleMouseEvent(eventType, this.pointerEvent);
        if (newState != null) {
            DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
                const prevState = this.currentState.constructor.name;
                const curState = newState.constructor.name;
                const eventName = e_mouse_event_type_1.EMouseEventTypeNames[eventType];
                const name = this.plot.plotName == null ? "" : `${this.plot.plotName} `;
                rc_js_util_1._Debug.verboseLog(`${name}${prevState} -> ${curState} (${eventName})`);
            });
            this.currentState = newState;
        }
    }
}
exports.PlotEventHandler = PlotEventHandler;
//# sourceMappingURL=plot-event-handler.js.map